// extracted by mini-css-extract-plugin
export default {"menu":"FollowUpTimeMenu_menu__OtRq4"};